<template>

<app-input-wrapper :errored="errored" class="checklist">

    <div class="checklist-item" :class="{'is-active': isChecked(key)}" v-on:click="onCheckClick(key)" v-for="(option, key) in options" :key="key">

        <div class="checklist-item-label">{{ option }}</div>

        <div class="checklist-item-check">

            <app-icon name="tick" />

        </div>

    </div>

</app-input-wrapper>

</template>

<script>

import mixinInput from '@/mixin/input.js'

export default {

	mixins: [mixinInput],

	props: ['options'],

	methods: {

        isChecked: function(key) {

            return this.$_.contains(this.value, key)

        },

		onCheckClick: function(key) {

            var value = this.$_.clone(this.value)

            if (this.$_.contains(value, key)) {

                value.splice(value.indexOf(key), 1)

            } else {

                value.push(key)

            }
           
			this.$emit('input', value)

		}

	}

}

</script>

<style scoped>

.checklist >>> .input-content-input {
    flex-direction: row;
    flex-wrap: wrap;
}

.is-tablet .checklist >>> .input-content-input {
    flex-direction: row!important;
}

.checklist-item {
    width: calc(25% - 8px);
    display: flex;
    flex-direction: row;
    align-items: center;
	cursor: pointer;
    margin-right: 10px;
    margin-bottom: 10px;
}

.is-tablet .checklist-item {
    width: calc(50% - 5px);
}

.is-mobile .checklist-item {
    width: 100%;
    margin-right: 0px;
    margin-bottom: 4px;
}

.is-desktop .checklist-item:nth-child(4n) {
    margin-right: 0px;
}

.is-tablet .checklist-item:nth-child(2n) {
    margin-right: 0px;
}

.checklist-item-label {
    display: flex;
    flex-direction: column;
    justify-content: center;
    height: 40px;
    flex-grow: 1;
    font-size: 14px;
    line-height: 16px;
    font-weight: 400;
    padding-left: 10px;
	border: 1px solid var(--color-grey-light);
    border-right-width: 0px;
	border-radius: 4px 0px 0px 4px;
	transition: all 100ms linear;
}

.is-desktop .checklist-item:not(.is-active):hover .checklist-item-label {
	border-color: var(--color-grey-highlight);
}

.checklist-item.is-active .checklist-item-label {
	border-color: var(--color-blue-light);
}

.is-desktop .checklist-item.is-active:hover .checklist-item-label {
	border-color: var(--color-blue-dark);
}

.checklist-item-check {
	width: 40px;
	height: 40px;
	font-size: 16px;
	text-align: center;
	line-height: 40px;
    border-radius: 0px 4px 4px 0px;
	border: 1px solid var(--color-grey-light);
	color: var(--color-grey-light);
	transition: all 100ms linear;
	flex-shrink: 0;
}

.is-desktop .checklist-item:hover .checklist-item-check {
	color: var(--color-grey-highlight);
	border: 1px solid var(--color-grey-highlight);
}

.checklist-item.is-active .checklist-item-check {
	color: #fff;
	background-color: var(--color-blue-light);
	border: 1px solid var(--color-blue-light);
}

.is-desktop .checklist-item.is-active:hover .checklist-item-check {
	background-color: var(--color-blue-dark);
	border: 1px solid var(--color-blue-dark);
}

</style>